import curd from '../curd'

const BASE_PATH = '/org'

export default curd(BASE_PATH, {
  getOrgTypes: () => ({
    url: `${BASE_PATH}/type`,
    method: 'GET'
  })
})



// WEBPACK FOOTER //
// ./src/apis/modules/Org.js